"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/**
 * 修改可提现金额
 */
var _default = exports.default = {
  props: {
    // 1 代理 2 商户
    type: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      editWithDialog: false,
      withList: []
    };
  },
  mounted: function mounted() {},
  methods: {
    /**
     * 显示dialog
     */
    showDialog: function showDialog(id) {
      this.editWithDialog = true;
      console.log(id);
      this.getList(id);
    },
    /**
     * 获取修改记录
     */
    getList: function getList(id) {
      var _this = this;
      this.$get('agentapi/business/modify_user_accout', {
        current_user_id: id
      }).then(function (res) {
        _this.withList = res.list;
      });
    }
  }
};